import script from "./AppTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTable.vue?vue&type=script&setup=true&lang=js"

import "./AppTable.vue?vue&type=style&index=0&id=499033fa&scoped=true&lang=css"
import "./AppTable.vue?vue&type=style&index=1&id=499033fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-499033fa"]])

export default __exports__